import { apiTypeId } from "./configurationApi.types";

export const getSystemTypeName = (systemType: apiTypeId) => {
  switch (systemType) {
    case apiTypeId.SIOEO:
      return 'SIOEO';
    case apiTypeId.SIOEPKZ:
      return 'SIOEPKZ';
  }
};

export const getSyncTime = (syncTimeMinutes: number) => {
  if (syncTimeMinutes) {
    return syncTimeMinutes <= 60
      ? `${syncTimeMinutes} minut`
      : `${Math.floor(syncTimeMinutes / 60)} godz. ${syncTimeMinutes % 60} minut`;
  } else return '0 minut';
};